/** The different types of Bills that are available. */
export enum BillType {
  /** House bill */
  HR = 'hr',

  /** Senate bill */
  S = 's',

  /** House Joint Resolution */
  HJRES = 'hjres',

  /** Senate Joint Resolution */
  SJRES = 'sjres',

  /** House Concurrent Resolution */
  HCONRES = 'hconres',

  /** Senate Concurrent Resolution */
  SCONRES = 'sconres',

  /** House Simple Resolutions */
  HRES = 'hres',

  /** Senate Simple Resolutions */
  SRES = 'sres'
}
